import React from 'react'
import PropTypes from 'prop-types'
import { fetchCourseLmsData, postLmsSettings } from '../../actions'
import { routePaths } from '../../urls'
import Alert from '../Alert.js'

export default class SetupForm extends React.Component {
  static propTypes = {
    coursenum: PropTypes.string.isRequired,
    canvasCoursenum: PropTypes.string,
    canvasUrl: PropTypes.string,
    formErrorMsg: PropTypes.string,
    msgClass: PropTypes.string,
  }

  static contextTypes = {
    store: PropTypes.object,
    router: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      canvasUrlInput: this.props.canvasUrl || '',
      canvasCoursenumInput: this.props.canvasCoursenum || '',
    }
  }

  componentDidMount() {
    let { store } = this.context
    store.dispatch(fetchCourseLmsData(this.props.coursenum))
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      canvasUrlInput: nextProps.canvasUrl,
      canvasCoursenumInput: nextProps.canvasCoursenum,
    })
  }

  postFormData = event => {
    event.preventDefault()

    let { store } = this.context
    store.dispatch(
      postLmsSettings(this.props.coursenum, {
        canvasUrl: this.state.canvasUrlInput,
      })
    )
    this.context.router.history.push(routePaths.canvasAuthorize)
  }

  handleCanvasUrlChange = event => {
    this.setState({ canvasUrlInput: event.target.value })
  }
  render() {
    let msg =
      this.props.formErrorMsg === '' ? null : (
        <Alert
          bootstrapClass={this.props.msgClass}
          message={this.props.formErrorMsg}
        />
      )

    return (
      <div>
        {msg}
        <form onSubmit={this.postFormData} className="canvas-settings-form">
          <label>
            Institution Canvas URL:{' '}
            <input
              className="canvas-setting"
              type="text"
              name="lms_url"
              value={this.state.canvasUrlInput}
              onChange={this.handleCanvasUrlChange}
            />
          </label>
          <div className="help-text">
            <p className="text-warning">
              If you are unsure about your institution&apos;s URL, please{' '}
              <a href="/contact">contact us.</a>
            </p>
          </div>
          <br />
          <div className="form-control-wrapper">
            <button
              className="btn btn-myed btn-primary btn-primary-myed"
              type="submit"
            >
              Next <div className="fas fa-chevron-right ml-2" />
            </button>
          </div>
        </form>
      </div>
    )
  }
}
